import React from 'react';
import { useNavigate } from 'react-router-dom';
import AskCards from '../components/AskCards';

// Where an "ask" notification lands: everything the office has asked you that is still
// open — answered or not, so an RSVP can be changed until it closes.
export default function MyAsks() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: '#f3f4f6' }}>
      <div style={{ background: '#1e3a5f', color: '#fff', padding: '16px 18px', paddingTop: 'max(env(safe-area-inset-top), 16px)', display: 'flex', alignItems: 'center', gap: 12 }}>
        <button onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/'))} aria-label="Back" style={{ background: 'none', border: 'none', color: '#fff', fontSize: 24, lineHeight: 1, cursor: 'pointer', padding: 0 }}>‹</button>
        <div>
          <div style={{ fontSize: 18, fontWeight: 800 }}>Asks from the office</div>
          <div style={{ fontSize: 12.5, opacity: 0.8 }}>Questions, RSVPs and things to acknowledge</div>
        </div>
      </div>
      <div style={{ maxWidth: 640, margin: '0 auto', padding: '18px 16px 40px' }}>
        <AskCards waitingOnly={false} emptyText="Nothing is waiting on you. When the office asks something, it shows up here and on your home screen." />
      </div>
    </div>
  );
}
